export const SSN_FIELDS = [
    "Social Security Number",
    "Original Owner SSN",
    "Joint Social Security Number",
    "Minor Social Security Number",
    "Beneficiary 1: SSN",
    "Beneficiary 2: SSN",
    "Beneficiary 3: SSN",
    "Beneficiary 4: SSN",
    "Beneficiary 5: SSN",
    "Beneficiary 6: SSN",
    "Beneficiary 7: SSN",
    "Beneficiary 8: SSN",
]

export const DECIMAL_FIELDS = [
    "Account Value"
]

export const CLIENT_DOLLAR_AMOUNT_FIELDS = [
    "Annual Income", 
    "Net Worth", 
    "Liquid Assets",
    "All current holdings ($) Mutual Funds / ETFs",
    "All current holdings ($) Annuities",
    "All current holdings ($) Stocks",
    "All current holdings ($) Bonds",
    "All current holdings ($) Alternative",
    "All current holdings ($) Other"    
]

export const ACCOUNT_DOLLAR_AMOUNT_FIELDS = ["Account Value"]

export const RETIRED_RELATED_FIELDS = [
    "Employer Name", 
    "Employer Address", 
    "Employer City", 
    "Employer State", 
    "Employer Zip", 
    "Length of Employment (yrs)",
    "Employer", 
    "Type Of Business", 
    "Years Employed", 
    "Business Phone"
]

export const INVESTMENT_EXP_FIELDS = [
    "Margin Trading IE",
    "Options Trading IE",
    "REITS / Alt IE"
]

export const DOB_INVESTMENT_EXP_FIELDS = [
    "Stocks IE",
    "Bonds IE",
    "Mutual Funds IE",
    "Annuities IE"
]

export const PRIMARY_ADDRESS_FIELDS = [
    "Primary Address",
    "Primary City",
    "Primary State",
    "Primary Zip"
]

export const ENTITY_ADDRESS_FIELDS = [
    "Entity Address",
    "Entity City",
    "Entity State",
    "Entity Zip"
]

export const TRUST_ADDRESS_FIELDS = [
    "Trust Address",
    "Trust City",
    "Trust State",
    "Trust Zip"
]